const React = require('react'),
    mui = require('material-ui'),
    {CardText} = mui;

const DashboardSpinner = React.createClass({displayName: "DashboardSpinner",

    getInitialState() {
        return {
            isVisible: false
        };
    },

    show() {
        this.setState({
            isVisible: true
        });
    },

    hide() {
        this.setState({
            isVisible: false
        });
    },

    isVisible() {
        return this.state.isVisible;
    },

    render() {
        const el = this.state.isVisible ?
            (
                React.createElement(CardText, {className: "dashboard-spinner", zDepth: 1, style: {
                    zIndex: '20',
                    fontSize: '15px',
                    position: 'fixed',
                    right: '1px',
                    marginRight: '90px',
                    float: 'right',
                    bottom: '16px',
                    boxShadow: 'none !important',
                    backgroundColor: '#fff !important',
                    borderRadius: '50%',
                    margin: '0px',
                    padding: '37px'
                }}
                )
            ) : null;

        return el;
    }
});

module.exports = DashboardSpinner;



/** WEBPACK FOOTER **
 ** ./src/views/Dashboard/DashboardSpinner.jsx
 **/